import movingLabel from '../modules/movingLabel.js';
import togglePanel from '../../shared/toggle-panel.js';

(function (Drupal, $) {
  Drupal.behaviors.forms = {
    attach: (context, settings) => {
      // Fallback multi-navigateurs pour la validation email (le « @ ») :
      // Safari/iOS et d'anciens navigateurs bloquent la soumission sans
      // afficher la bulle native que montrent Chrome/Firefox.
      enableEmailValidationFallback(context && context.querySelectorAll ? context : document);

      // Where are you block is loaded asynchronously.
      if (
        context === document.querySelector('.block-medicalstageblock') ||
        context === document.querySelector('#medical-stage-wrapper')
      ) {
        if (document.body.getAttribute('data-forms-whereAreYou') === 'true') {
          return;
        }
        whereAreYou();
        document.body.setAttribute('data-forms-whereAreYou', 'true');
      }

      if (context === document.querySelector('.faq-search')) {
        enableMovingLabel();
      }

      // Newsletter form is loaded asynchronously.
      if (context === document.querySelector('.newsletter-form')) {
        enableMovingLabel();
      }

      // Contact form is loaded asynchronously.
      if (context === document.querySelector('.contact-form')) {
        enableMovingLabel();
      }

      if (context === document.getElementById('preregister-wrapper')) {
        enableMovingLabel();
      }

      if (context === document) {
        if (document.body.getAttribute('data-forms') === 'true') {
          return;
        }
        enableMovingLabel();
        profileModal();
        showCheckboxInfo();
        proposeTestimony();
        whereAreYou();
        showPassword();

        // Active the sticky link.
        const panel = document.querySelector('.block-medicalstageblock');
        if (context === panel || context === document.querySelector('.ddmo-medical-stage')) {
          const stickyWhere = document.querySelector('.menu-where-are-you');

          if (!panel.classList.contains('is-hidden')) {
            stickyWhere.classList.add('is-active');
          }
        }
        document.body.setAttribute('data-forms', 'true');
      }
    }
  };

  function proposeTestimony() {
    // Uncheck donor option if the donor radio is not selected.
    const iamRadios = document.querySelectorAll('input[name="donor_i_am"]');
    [].forEach.call(iamRadios, (iamOption) => {
      iamOption.addEventListener('click', (e) => {
        if (iamOption.value !== 'donor') {
          const donorOptionList = document.querySelectorAll('.donor-status--wrapper .form__radio');
          [].forEach.call(donorOptionList, (option) => {
            option.checked = false;
          });

          // Reset the list.
          document.getElementById('edit-donor-transplanted-by').selectedIndex = 0;
        }
      });
    });
  }

  function profileModal() {
    // Open modal.
    const avatarList = document.querySelectorAll('.form__item-select-avatar .form__radio');
    [].forEach.call(avatarList, (avatar) => {
      avatar.addEventListener('click', (e) => {
        // Close the modal after choice, then submit.
        $.fn.colorbox.close();
        const duration = 500;
        setTimeout(() => {
          document.querySelector('#edit-button-avatar').click();
        }, duration);
      });
    });
  }

  /**
   * Cross-browser fallback for the native email validation message.
   *
   * Chrome/Firefox affichent une bulle native sur un <input type="email">
   * invalide ; Safari (notamment iOS) et d'anciens navigateurs bloquent la
   * soumission sans rien afficher. On uniformise via la Constraint Validation
   * API en injectant un message inline cohérent avec le style du thème
   * (.form-item__error-message). La soumission reste bloquée nativement.
   *
   * @param {ParentNode} context
   *   Racine de recherche des champs email.
   *
   * @return {void};
   */
  function enableEmailValidationFallback(context) {
    const inputs = context.querySelectorAll('input[type="email"]');
    [].forEach.call(inputs, (input) => {
      if (input.dataset.emailFallback === 'true') {
        return;
      }
      input.dataset.emailFallback = 'true';

      const wrapper = input.closest('.form-item') || input.parentNode;

      function clearError() {
        input.classList.remove('error');
        input.removeAttribute('aria-invalid');
        const existing = wrapper.querySelector('.js-email-error');
        if (existing) {
          existing.remove();
        }
      }

      function showError(message) {
        input.classList.add('error');
        input.setAttribute('aria-invalid', 'true');
        let el = wrapper.querySelector('.js-email-error');
        if (!el) {
          el = document.createElement('div');
          el.className = 'form-item__error-message js-email-error';
          el.setAttribute('role', 'alert');
          wrapper.appendChild(el);
        }
        el.textContent = message;
      }

      // En interceptant l'événement « invalid » on supprime la bulle native
      // (inconsistante) tout en gardant le blocage de soumission du navigateur.
      input.addEventListener('invalid', (event) => {
        event.preventDefault();
        if (input.validity.valueMissing) {
          showError(Drupal.t('Veuillez renseigner votre adresse e-mail.'));
        } else if (input.validity.typeMismatch) {
          // typeMismatch couvre aussi bien « pas de @ » que « plusieurs @ » :
          // on distingue le double @ pour afficher le message attendu.
          const atCount = (input.value.match(/@/g) || []).length;
          if (atCount > 1) {
            showError(Drupal.t('La partie précédée du « @ » ne doit pas contenir le caractère « @ ».'));
          } else {
            showError(Drupal.t('L’adresse e-mail doit contenir un « @ » (exemple : nom@domaine.fr).'));
          }
        } else {
          showError(Drupal.t('Adresse e-mail invalide.'));
        }
      });

      input.addEventListener('input', () => {
        if (input.checkValidity()) {
          clearError();
        }
      });

      // checkValidity() redéclenche « invalid » (sans bulle) à la sortie du champ.
      input.addEventListener('blur', () => {
        if (input.value !== '') {
          input.checkValidity();
        }
      });
    });
  }

  /**
   * Enable moving label.
   *
   * @return {void};
   */
  function enableMovingLabel() {
    const labelList = document.querySelectorAll('.form label, .newsletter-form__newsletter-form label');
    [].forEach.call(labelList, (label) => {
      if (!label.parentNode.classList.contains('form__item-date-update')) {
        movingLabel(label);
      }
    });
  }

  /**
   * Emulate radio from checkbox.
   *
   * @return {void};
   */
  function whereAreYou() {
    // Move bubble when the block actually loaded.
    if (document.querySelector('.block-medicalstageblock')) {
      moveTextBubble();
    }

    // Avoid double execution.
    if (window.whereAreYouEnabled) {
      return;
    }

    window.whereAreYouEnabled = true;

    document.addEventListener('click', (e) => {
      // Close the text panel.
      if (e.target.closest('#close--text-container')) {
        closePanel(e.target);
      }

      // Manage click on checkboxes.
      if (e.target.matches('.med__choices .form__checkbox')) {
        optionChange(e.target);
      }

      // Manage click on menu.
      if (e.target.closest('.menu-where-are-you')) {
        e.preventDefault();
        toggleWithSticky(e.target.closest('.menu-where-are-you'));
        moveTextBubble();
      }

      // Button in mobile header.
      const selectorWhereAreYou = '.where-are-you-mobile';
      if (e.target.matches(selectorWhereAreYou) || e.target.closest(selectorWhereAreYou)) {
        toggleWithSticky(document.querySelector(selectorWhereAreYou));
        moveTextBubble();
      }
    }, false);

    document.querySelector('.burger-nav').addEventListener('click', (e) => {
      // Manage click on menu.
      const selectorWhereAreYou = '.menu-where-are-you';
      if (e.target.closest(selectorWhereAreYou)) {
        e.preventDefault();
        toggleWithSticky(e.target.closest(selectorWhereAreYou));
        moveTextBubble();
        document.querySelector('.burger-nav').dispatchEvent(new CustomEvent('hide'));
      }
    }, false);
  }

  /**
   * Reposition the block info bellow the right item for small screens..
   *
   * @return {void};
   */
  function moveTextBubble() {
    const panelText = document.querySelector('.med__text-container');

    if (window.matchMedia('(max-width: 1366px)').matches) {
      const activeStepCB = document.querySelector('.med__choices .form__checkbox:checked');
      if (activeStepCB) {
        const commonParent = document.getElementById('medical-stage-wrapper');
        const arrowOffset = 30;
        let top = activeStepCB.parentNode.getBoundingClientRect().top + activeStepCB.parentNode.getBoundingClientRect().height - commonParent.getBoundingClientRect().top;
        top += arrowOffset;
        panelText.style.top = `${top}px`;
      }
    }
  }

  function closePanel(closeCrossPanel) {
    const panelText = closeCrossPanel.closest('.med__text-container');
    panelText.classList.add('is-hidden');
  }

  function optionChange(cb) {
    // Uncheck all.
    const cbList = document.querySelectorAll('.med__choices .form__checkbox');
    Array.prototype.forEach.call(cbList, (check) => {
      check.checked = false;
    });

    cb.checked = true;

    const closeCrossPanel = document.getElementById('close--text-container');
    if (closeCrossPanel) {
      closeCrossPanel.click();
    }
  }

  /**
   * Show or hide password.
   *
   * @returns {void}
   */
  function showPassword() {
    const showPasswordList = document.querySelectorAll('.show-password');
    [].forEach.call(showPasswordList, (button) => {
      button.addEventListener('click', (e) => {
        const input = button.previousElementSibling;
        button.classList.toggle('show-password--is-hidden');

        if (input.getAttribute('type') === 'password') {
          input.setAttribute('type', 'text');
        } else {
          input.setAttribute('type', 'password');
        }
      });
    });
  }

  function toggleWithSticky(stickyWhere) {
    const panel = document.querySelector('.block-medicalstageblock');
    if (!panel) {
      return;
    }

    panel.classList.toggle('is-hidden');

    // Toggle sticky link.
    if (panel.classList.contains('is-hidden')) {
      stickyWhere.classList.remove('is-active');
    } else {
      stickyWhere.classList.add('is-active');

      setTimeout(() => {
        // Scroll to the panel.
        const scrollDestination = panel.getBoundingClientRect().top + document.documentElement.scrollTop;
        const headerOffset = document.querySelector('.header__nav-inner').getBoundingClientRect().height;

        // Avoid anchor panel.
        let headerAnchorHeight = 0;
        const headerAnchor = document.querySelector('.header__anchors');
        if (headerAnchor) {
          headerAnchorHeight = headerAnchor.getBoundingClientRect().height;
        }

        window.scroll({
          top: scrollDestination - headerOffset - headerAnchorHeight - headerAnchorHeight,
          left: 0,
          behavior: 'smooth',
        });
      }, 100);
    }

    const layoutWrapper = document.querySelector('.inner-wrap.layout');
    if (layoutWrapper) {
      layoutWrapper.classList.toggle('no-panel-spacing');
    }
  }

  /**
   * Toggle checkbox information.
   *
   * @return {void};
   */
  function showCheckboxInfo() {
    const cb = document.querySelector('.form__item-optin label span');
    if (!cb) {
      return;
    }

    const cbEl = document.querySelector('.form__item-optin input[type="checkbox"]');
    cbEl.addEventListener('click', (e) => {
      if (cbEl.checked) {
        document.querySelector('.confirm-accept-optin').dispatchEvent(new CustomEvent('hide'));
      }
    });

    const optinPanel = document.querySelector('.confirm-accept-optin');
    if (optinPanel) {
      togglePanel(cb, {
        panel: 'function',
        findPanel: () => optinPanel,
        outsideClose: false,
      });
    }

    // Avoid checking the box.
    cb.addEventListener('click', (e) => {
      e.preventDefault();
    });
  }
}(Drupal, jQuery));
